/**
 * Copyright (C) 2025 GIP-RECIA, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { difference } from './objectUtils.ts'

function onDiff<T extends object>(
  callback: (diffs: Map<keyof T, T[keyof T]>, newValue: Partial<T>, oldValue: Partial<T>) => void,
): (newValue: Partial<T> | undefined, oldValue: Partial<T> | undefined) => void {
  return (newValue, oldValue) => {
    const diffs = difference(newValue, oldValue)
    if (diffs.size === 0)
      return
    callback(diffs, newValue ?? {}, oldValue ?? {})
  }
}

export {
  onDiff,
}
